export const DEFAULT_COUNTRY_CODE = 'BY';
